import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { "m-tb-1": "" }
const _hoisted_2 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_app_location_search = _resolveComponent("app-location-search")!
  const _component_app_business_stage_input = _resolveComponent("app-business-stage-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      "custom-class": "App-Create-Business-Modal App-Unpadded",
      "model-value": _ctx.isModalOpen,
      width: "550px",
      "show-close": _ctx.showClose,
      "close-on-click-modal": _ctx.showClose,
      "close-on-press-escape": _ctx.showClose,
      onOpen: _ctx.opened,
      title: "Create Startup Profile",
      center: "",
      "append-to-body": true,
      "lock-scroll": true,
      "open-delay": 200,
      "before-close": _ctx.closeModal,
      "close-delay": 200
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            "is-block": "",
            icon: "el-icon-check",
            onClick: _ctx.submit,
            size: "large",
            type: "primary",
            disabled: _ctx.disabledSave || _ctx.loading
          }, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
              _createTextVNode(" Save Startup Profile ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, {
          always: true,
          "max-height": "70vh"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_form, {
                onSubmit: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["prevent"])),
                class: "App-Styled-Form",
                "label-position": 'top',
                "label-width": "100px",
                model: _ctx.form,
                style: {"margin-top":"12px"},
                rules: _ctx.rules
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "name",
                    label: "Name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        placeholder: "E4T",
                        modelValue: _ctx.form.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    prop: "industry",
                    label: "Industry"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.industry,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.industry) = $event)),
                        placeholder: "Industry: ex: Edtech",
                        "w-100": ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.industries, (ind) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              value: ind,
                              label: ind,
                              key: `${ind}-ind`
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_space, null, {
                                  default: _withCtx(() => [
                                    _cache[15] || (_cache[15] = _createElementVNode("i", { class: "App-Loc-Icon el-icon-business" }, null, -1)),
                                    _createElementVNode("span", null, _toDisplayString(ind), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    prop: "businessModel",
                    label: "What is your business model?"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.businessModel,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.businessModel) = $event)),
                        placeholder: "Business Model: ex: Edtech",
                        "w-100": ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessModels, (ind) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              value: ind,
                              label: ind,
                              key: `${ind}-ind`
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_space, null, {
                                  default: _withCtx(() => [
                                    _cache[16] || (_cache[16] = _createElementVNode("i", { class: "App-Loc-Icon el-icon-business" }, null, -1)),
                                    _createElementVNode("span", null, _toDisplayString(ind), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_divider),
                  _createVNode(_component_app_location_search, {
                    label: "Where are you based?",
                    size: 'default',
                    modelValue: _ctx.form.location,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.location) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_divider),
                  _createVNode(_component_app_business_stage_input, {
                    modelValue: _ctx.form.stage,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.stage) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_1, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", null, [
                      _createElementVNode("h4", { "m-tb-0": "" }, "Do you have coFounders?")
                    ], -1)),
                    _createVNode(_component_el_switch, {
                      modelValue: _ctx.tempform.hasCoFounders,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tempform.hasCoFounders) = $event)),
                      "active-text": "Yes, I do",
                      "inactive-text": "No, I don't"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_el_space, {
                    "w-100": "",
                    style: {"justify-content":"space-between"},
                    alignment: "center",
                    gutter: "12",
                    wrap: false
                  }, {
                    default: _withCtx(() => [
                      (_ctx.tempform.hasCoFounders)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            prop: "coFoundersSize",
                            label: "How many co-Founders?"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input_number, {
                                "w-100": "",
                                controls: false,
                                placeholder: "Nbr of co-founders",
                                modelValue: _ctx.form.coFoundersSize,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.coFoundersSize) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, {
                        prop: "teamSize",
                        label: "Team Size (Founders & others)"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input_number, {
                            "w-100": "",
                            controls: false,
                            placeholder: "How big is the team?",
                            modelValue: _ctx.form.teamSize,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.teamSize) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_divider),
                  _createVNode(_component_el_form_item, {
                    prop: "website",
                    label: "Website if any"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        placeholder: "https://equity4talent.com",
                        modelValue: _ctx.form.website,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.website) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_divider),
                  _createVNode(_component_el_form_item, {
                    prop: "foundingYear",
                    label: "Founding Year"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        "w-100": "",
                        modelValue: _ctx.form.foundingYear,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.foundingYear) = $event)),
                        controls: false,
                        placeholder: "Pick a year"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    prop: "marketSize",
                    label: "Market Size"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        controls: false,
                        placeholder: "200,000",
                        modelValue: _ctx.form.marketSize,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.marketSize) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    prop: "funding",
                    label: "Funds Raised"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_space, { size: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.funding.currency,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.funding.currency) = $event)),
                            placeholder: "Currency",
                            style: {"width":"150px"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "£ (Pound)",
                                value: "gbp"
                              }),
                              _createVNode(_component_el_option, {
                                label: "$ (US Dollars)",
                                value: "usd"
                              }),
                              _createVNode(_component_el_option, {
                                label: "€ (Euros)",
                                value: "euro"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_el_input_number, {
                            "w-100": "",
                            controls: false,
                            placeholder: "200,000",
                            modelValue: _ctx.form.funding.amount,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.funding.amount) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    prop: "about",
                    label: "Startup description"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        rows: "5",
                        type: "textarea",
                        placeholder: "Startup description",
                        modelValue: _ctx.form.about,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.about) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ])
          ]),
          _: 1
        })), [
          [_directive_loading, _ctx.loading]
        ])
      ]),
      _: 1
    }, 8, ["model-value", "show-close", "close-on-click-modal", "close-on-press-escape", "onOpen", "before-close"])
  ]))
}